<template>
  <b-modal
    ref="dataTreePickerModal"
    hide-footer
    centered
    title="Data tree picker"
    size="lg"
    class="data-tree-picker-modal"
    >
    <div v-if="loaded">
      <TreeView
        :data="tree"
        allow-copy-from-depth="2"
        @onSelect="buildExpression"
      />
    </div>
    <LoadingSpinner
      v-else
      color="#bbb"
      size="64"
    />
    <input
      class="data-tree-picker-modal__copyInput"
      type="hidden"
      ref="expInput"
      :value="expression"
    >
  </b-modal>
</template>

<script>
import { vuex } from 'vue'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import { mapState } from 'vuex';
// components
import LoadingSpinner from '@/components/LoadingSpinner'

let $ = window.$

export default {
  components: {
    LoadingSpinner
  },
  data () {
    return {
      loading: {
        dmodels: false,
        umodels: false,
        computed: false,
        workspaces: false
      },
      loaded: false,
      // models
      dmodels: null,
      umodels: null,
      computed: null,
      workspaces: null,

      tree: null,
      expression: null
    }
  },
  watch: {
    loading: {
      handler () {
        for (let model in this.loading) {
          if (!this.loading[model]) return
        }

        this.buildTree()
        this.loaded = true
      },
      deep: true
    },
    models_dashboardModel: {
      handler () {
        this.buildDashboardModelTree()
        this.buildTree()
      },
      deep: true
    },
    fbUserModels: {
      handler () {
        this.buildUserModelTree()
        this.buildTree()
      },
      deep: true
    },
    fbWorkspaceModels: {
      handler () {
        this.buildWorkspacesModelTree()
        this.buildTree()
      },
      deep: true
    },
    computedProps: {
      handler () {
        this.buildComputedPropsTree()
        this.buildTree()
      },
      deep: true
    }
  },
  computed: {
    ...mapState([
      'userId',
      'models_dashboardModel',
      'fbUserModels',
      'fbWorkspaceModels',
      'computedProps'
    ])
  },
  methods: {
    buildTree () {
      const tree = {}

      if (this.dmoldels) tree.DashboardModels = this.dmoldels
      if (this.umodels) tree.UserModels = this.umodels
      if (this.computed) tree.ComputedProps = this.computed
      if (this.workspaces) tree.WorkspaceModels = this.workspaces

      this.tree = tree
    },
    buildExpression (path, asArray) {
      const type = path.splice(0, 1)
      let expPath = ''

      for (let item of path) {
        if (typeof parseInt(item) === 'number' && !isNaN(parseInt(item))) expPath += `[${item}]`
        else expPath += `.${item}`
      }

      expPath = expPath.slice(1)

      let exp

      switch (type[[0]]) {
        case 'DashboardModels': exp = `$getDashboardModel('${expPath}')`
          break
        case 'UserModels': exp = `$FBUserModel('${expPath}')`
          break
        case 'ComputedProps': exp = expPath
          break
        case 'WorkspaceModels': exp = `$getWorkspaceData('${expPath}')`
          break
      }

      this.expression = asArray ? `$getDataGridVals(${exp})` : exp

      this.copyToClipboard()
    },
    buildDashboardModelTree () {
      return null
      // db.getRef('models').once('value', (snapshot) => {
      //   console.log('builddatat tree')
      //   this.dmoldels = snapshot.val()
      //   this.loading.dmodels = true
      // })
    },
    buildUserModelTree () {
      return null
      // db.getRef(`userWidgetsData/${this.userId}`).once('value', (snapshot) => {
      //   this.umodels = snapshot.val()
      //   this.loading.umodels = true
      // })
    },
    buildComputedPropsTree () {
      return null
      this.buildingModelTree = true
      this.modelTree = null
      // db.getRef(`widgetsComputed`).once('value', (snapshot) => {
      //   const widgetsComputed = snapshot.val()
      //   const computed = {}
      //   const computedVals = {}

      //   if (widgetsComputed) {
      //     for (let key in widgetsComputed) {
      //       if (!widgetsComputed[key]) continue
      //       computed[key] = new Function(widgetsComputed[key])
      //     }

      //     for (let key in computed) {
      //       try {
      //         computedVals[key] = computed[key]()
      //       } catch (err) {
      //         computedVals[key] = `Error: ${err.message}`
      //       }
      //     }
      //   }

      //   this.computed = (widgetsComputed) ? computedVals : null
      //   this.loading.computed = true
      // })
    },
    buildWorkspacesModelTree () {
      return
      if (window.$getWorkspaceData) this.workspaces = window.$getWorkspaceData()
      this.loading.workspaces = true
    },
    copyToClipboard () {
      const input = this.$refs.expInput
      input.setAttribute('type', 'text')

      const showFail = () => {
        alert(`Couldn't copy node expression in clipboard. Expression is: ${this.expression}`)
      }

      setTimeout(() => {
        input.select()

        try {
          const successful = document.execCommand('copy');
          successful ? alert('Data node expression copied!') : showFail()
        } catch (err) {
          showFail()
        }

        input.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()

        this.expression = null
      }, 100)
    }
  },
  created () {
    // setTimeout(() => {
   //   this.buildDashboardModelTree()
      // this.buildUserModelTree()
      // this.buildComputedPropsTree()
      // this.buildWorkspacesModelTree()
    // }, 1000)

    // eventBus.$on('showDataTreePickerModal', () => {
      // if (this.$refs.dataTreePickerModal) this.$refs.dataTreePickerModal.show()
    // })
  },

}
</script>

<style scoped>
.data-tree-picker-modal__copyInput {
  position: absolute;
  opacity: 0;
}
</style>
